import axios from 'axios'

/**
 * **文件鉴权下载**
 *
 * - 当文件小于等于分片大小时常规上传
 * - 当文件大于分片大小时分片上传
 * - 推荐作为全局方法使用，如：this.$downlaod(fileId)
 *
 * @author 方跃明
 * @param {String} fileId 文件ID或url，若以http或/开头则为url
 * @param {Boolean} options.save 是否下载到本地，false = 不下载（仅返回地址）、true = 下载
 * @param {String} options.filename 下载文件名
 * @param {Object} options.request 请求客户端，默认axios
 * @param {String} options.method 请求方法，默认：get
 * @param {String} options.downloadApi 下载API地址
 * @param {String} options.responseType 请求类型，默认：arraybuffer
 * @param {String} options.type 请求类型，默认：application/force-download
 * @param {Object} options.params 请求参数
 * @return {String} 文件本地下载地址，options.save = true 时触发下载到本地
 */
export default async (fileId, options) => {
  options = {
    responseType: 'arraybuffer',
    type: 'application/force-download',
    request: axios,
    method: 'get',
    downloadApi: '',
    filename: Date.now(),
    save: false,
    ...options
  }

  const { request, method, responseType, type, params, downloadApi, filename, save } = options
  const url = fileId.startsWith('/') || fileId.startsWith('http') ? fileId : downloadApi + fileId
  const result = await request({ method, url, params, responseType })
  const blob = new Blob([result], { type })
  const href = URL.createObjectURL(blob)
  if (!save) return href

  const a = document.createElement('a')
  a.setAttribute('href', href)
  a.setAttribute('download', filename)
  a.click()
  return href
}
